"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _canvaLogo = _interopRequireDefault(require("bender-url!FileManagerImages/images/canva-logo.png"));

var _loadCanva = _interopRequireDefault(require("../../utils/loadCanva"));

var _Canva = require("FileManagerCore/constants/Canva");

var _Constants = require("FileManagerCore/Constants");

var _reactRedux = require("react-redux");

var _Canva2 = require("FileManagerCore/selectors/Canva");

var _BrowserTest = require("UIComponents/utils/BrowserTest");

var _Actions = require("FileManagerLib/actions/Actions");

var _Canva3 = require("FileManagerCore/actions/Canva");

var CanvaButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CanvaButton, _Component);

  function CanvaButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CanvaButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CanvaButton).call(this, props));

    _this.handleCanvaApiLoaded = function () {
      if (_this.mounted && !window.__CANVA_API) {
        window.CanvaButton.initialize({
          apiKey: _Canva.CANVA_API_KEY
        }).then(function (canvaApi) {
          window.__CANVA_API = canvaApi;

          _this.props.canvaInitSucceeded();
        });
      }
    };

    _this.handleCanvaApiFailedLoad = function () {
      if (_this.mounted) {
        _this.props.canvaInitFailed();
      }
    };

    _this.openCanva = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Canva.CANVA_DEFAULT_TEMPLATE;

      _this.props.trackInteraction('Manage Files', 'create-canva-clicked');

      var options = {
        type: type
      };

      if (type.includes('custom:')) {
        var _type$split = type.split(':'),
            _type$split2 = (0, _slicedToArray2.default)(_type$split, 3),
            customType = _type$split2[1],
            dimensions = _type$split2[2];

        var _dimensions$split = dimensions.split('x'),
            _dimensions$split2 = (0, _slicedToArray2.default)(_dimensions$split, 2),
            width = _dimensions$split2[0],
            height = _dimensions$split2[1];

        options = {
          height: height,
          type: customType,
          width: width
        };
      }

      window.__CANVA_API.createDesign((0, _extends2.default)({
        publishLabel: 'Save'
      }, options, {
        onDesignPublish: function onDesignPublish(_ref) {
          var exportUrl = _ref.exportUrl;

          _this.props.importFile(exportUrl);
        }
      }));
    };

    _this.isLoaded = function () {
      return _this.props.canvaInitStatus === _Constants.RequestStatus.SUCCEEDED || !!window.__CANVA_API;
    };

    _this.isDownloading = function () {
      return _this.props.canvaDownloadStatus === _Constants.RequestStatus.PENDING;
    };

    _this.disabledReason = function () {
      if ((0, _BrowserTest.isIE11)()) {
        return _I18n.default.text('FileManagerLib.actions.canvaNotSupportedForIE11');
      } else if (_this.isDownloading()) {
        return _I18n.default.text('FileManagerLib.actions.canvaIsDownloading');
      } else if (!_this.props.canvaIsSupportedForFilter) {
        return _I18n.default.text('FileManagerLib.actions.canvaNotSupportedForFilter');
      } else if (!_this.isLoaded()) {
        return _I18n.default.text('FileManagerLib.actions.canvaNotLoaded');
      }

      return null;
    };

    _this.renderLoadingButton = function () {
      return _react.default.createElement(_UILoadingButton.default, {
        className: "canva-loading-button m-x-2",
        disabled: true,
        loading: true,
        size: "small",
        use: "tertiary-light"
      });
    };

    _this.mounted = false;
    return _this;
  }

  (0, _createClass2.default)(CanvaButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (!(0, _BrowserTest.isIE11)()) {
        this.props.canvaInitAttempted();
        (0, _loadCanva.default)().then(this.handleCanvaApiLoaded).catch(this.handleCanvaApiFailedLoad).done();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var disabledReason = this.disabledReason();
      var isDisabled = !!disabledReason;
      return _react.default.createElement(_UITooltip.default, {
        title: disabledReason
      }, this.isDownloading() ? this.renderLoadingButton() : _react.default.createElement(_UISelect.default, {
        className: "m-x-2",
        disabled: isDisabled,
        menuWidth: 312,
        onChange: function onChange(e) {
          return _this2.openCanva(e.target.value);
        },
        buttonUse: "tertiary-light",
        buttonSize: "small",
        placeholder: _react.default.createElement("div", null, _react.default.createElement(_UIImage.default, {
          alt: _I18n.default.text('FileManagerLib.actions.addFromCanva'),
          className: "m-x-1",
          height: 20,
          responsive: false,
          src: _canvaLogo.default
        }), _react.default.createElement(_FormattedMessage.default, {
          className: "canva-button-text m-x-1",
          message: "FileManagerLib.actions.addFromCanva"
        })),
        placement: "top left",
        value: "",
        options: _Canva.CANVA_TEMPLATE_OPTIONS.map(function (option) {
          return (0, _extends2.default)({}, option, {
            text: _I18n.default.text("FileManagerLib.canva.typeLabels." + option.languageKey)
          });
        })
      }));
    }
  }]);
  return CanvaButton;
}(_react.Component);

CanvaButton.propTypes = {
  canvaInitAttempted: _react.PropTypes.func.isRequired,
  canvaInitFailed: _react.PropTypes.func.isRequired,
  canvaDownloadStatus: _react.PropTypes.oneOf(Object.keys(_Constants.RequestStatus)).isRequired,
  canvaInitStatus: _react.PropTypes.oneOf(Object.keys(_Constants.RequestStatus)).isRequired,
  canvaInitSucceeded: _react.PropTypes.func.isRequired,
  canvaIsSupportedForFilter: _react.PropTypes.bool,
  importFile: _react.PropTypes.func.isRequired,
  trackInteraction: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    canvaInitStatus: (0, _Canva2.getCanvaInitStatus)(state),
    canvaDownloadStatus: (0, _Canva2.getCanvaDownloadStatus)(state),
    canvaIsSupportedForFilter: (0, _Canva2.getCanvaIsSupportedForFilter)(state)
  };
};

var mapDispatchToProps = {
  canvaInitAttempted: _Canva3.canvaInitAttempted,
  canvaInitFailed: _Canva3.canvaInitFailed,
  canvaInitSucceeded: _Canva3.canvaInitSucceeded,
  trackInteraction: _Actions.trackInteraction
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CanvaButton);

exports.default = _default;
module.exports = exports.default;